











































import 'vue-awesome/icons/user'
import 'vue-awesome/icons/question'
import 'vue-awesome/icons/regular/credit-card'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/calendar-alt'
import 'vue-awesome/icons/list'
import 'vue-awesome/icons/chart-bar'
import 'vue-awesome/icons/plus-square'

Vue.component 'mt-tabbar', require('mint-ui/lib/tabbar').default
Vue.component 'mt-tab-item', require('mint-ui/lib/tab-item').default

require 'mint-ui/lib/header/style.css'
require 'mint-ui/lib/tabbar/style.css'
require 'mint-ui/lib/tab-item/style.css'

export default
  name: 'mobile'
  components: `{
    about_hm_modal: require('../inside/onboarding/about_hm_modal.vue').default,
    forecast:    require('components/inside/elements/forecast.vue').default,
    demo_bar:       () => import(/* webpackChunkName: "demo_bar" */'components/inside/demo_bar.vue'),
    payment_bar: require('components/inside/payment_bar.vue').default,
    offline_bar: require('components/inside/offline_bar.vue').default,
    ios_prompt: () => import(/* webpackChunkName: "ios_prompt" */'components/mobile/ios_prompt.vue'),
    transactions_preview: () => import(/* webpackChunkName: "transactions_preview" */'components/inside/transactions_preview.vue'),
    transaction_current_popover: () => import(/* webpackChunkName: "current_popover" */'components/inside/elements/transactions/current_popover.vue'),
  }`
  data: ->
    selected: HM.router.currentRoute.name
  watch:
    '$route.name': (val) -> @selected = val
    selected: ->
      @$router.push { name: @selected }
  beforeCreate: -> @$store.dispatch 'loginUserFromLocalStorage'
  methods:
    newTransaction: ->
      @$store.dispatch('initTransaction', {}).then (new_transaction) =>
        @$store.dispatch('selectTransaction', new_transaction)
